import styled from 'styled-components';

export const Titulo = styled.h1`
  font-size: 36px;
  font-family: roboto;
  color: #999;
  font-weight: 700;
`;
